<template>
    <div v-if="addingToWishlist" style="color: #C84C54;">
        <div uk-spinner="ratio: 1.3"></div>
    </div>
    <div v-else>
        <span v-if="isLead">
            <button class="remove-button-styling" style="color: #C84C54;" @click="handleClick">
                <BaseIcon height="40" stroke-width="1.5" width="40">
                    <IconHeartFilled v-if="inWishlist" />
                    <IconHeart v-else />
                </BaseIcon>
                <br>
                <span v-if="inWishlist" class="uk-text-small">Saved</span>
                <span v-else>Save</span>
            </button>
        </span>
        <button v-else class="remove-button-styling" style="color: #C84C54;" @click.prevent="modalStatusStore.showLeadModal()">
            <BaseIcon height="40" stroke-width="1.5" width="40">
                <IconHeartFilled v-if="inWishlist" />
                <IconHeart v-else />
            </BaseIcon>
            <span>Save</span>
        </button>
    </div>

</template>

<script setup>
import {computed, ref} from "vue";
import {storeToRefs} from "pinia";
import {useWishlistStore} from "../../stores/WishlistStore";
import useCookies from "../../composables/cookies";
import IconHeartFilled from "../icons/IconHeartFilled";
import IconHeart from "../icons/IconHeart";
import BaseIcon from "../ui/BaseIcon";
import {useModalStatusStore} from "../../stores/ModalStatusStore";

const props = defineProps({
    productId: Number
})

const wishlistStore = useWishlistStore()
const modalStatusStore = useModalStatusStore()
const {isLead} = useCookies()

const {
    productIds
} = storeToRefs(wishlistStore)

const addingToWishlist = ref(false)
const inWishlist = computed(() => productIds.value.includes(props.productId))

function handleClick() {
    if (inWishlist.value) {
        window.location.href = '/wishlist'
    } else {
        addingToWishlist.value = true

        wishlistStore.addToWishlist(props.productId)
            .then(function () {
                addingToWishlist.value = false;
            });
    }
}
</script>
